export const SPACE_TYPE = {
  COWORKING: 1,
  FLOOR_BTS: 2,
  EXCLUSIVE_OFFICE: 3,
  CATERING: 4,
  CLOSED_COWORKING: 91,
  CLOSED_FLOOR: 92,
  CLOSED_EXCLUSIVE_OFFICE: 93,
  CLOSED_CATERING: 94,
  WRONG_REGISTER: 98,
  DELETED_LEGAL_PROBLEM: 99,
};
